// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-list-item/carousel-article-list-item.component.scss
// module id = 184
// module chunks = 0